import { render, staticRenderFns } from "./DebtorPopover.vue?vue&type=template&id=5580b9f6&scoped=true&"
import script from "./DebtorPopover.vue?vue&type=script&lang=js&"
export * from "./DebtorPopover.vue?vue&type=script&lang=js&"
import style0 from "./DebtorPopover.vue?vue&type=style&index=0&id=5580b9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580b9f6",
  null
  
)

export default component.exports